import { Chip, tooltipClasses } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { createElement } from "react";
import { useTranslation } from "react-i18next";
import { TbBuildingSkyscraper } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { softColors } from "@/constants/colors";
import { hotelItems } from "@/constants/hotelItems";
import { NoMaxWidthTooltip } from "@/pages/DriverStatus.tsx/components/DriverStatusColumnTooltip";
import HotelStatusTooltip from "@/pages/HotelPlanning/arrival/components/table/components/HotelStatusTooltip";
import { IPlanPassenger } from "@/types/tasks.types";

export function HotelNameColumnCell({ value }: { value: string }) {
    const { t } = useTranslation();
    const status = hotelItems.find((status) => status.value === value) || {
        ...softColors.gray,
        component: () => TbBuildingSkyscraper,
        label: "Otel seçilmedi",
        tooltip: {
            title: "Otel seçilmedi",
            description: "Otel seçilmedi",
        },
        value: "",
    };
    return (
        <div className="flex items-center py-1 h-full">
            {(status && (
                <NoMaxWidthTooltip
                    arrow
                    sx={{
                        [`& .${tooltipClasses.tooltip}`]: {
                            backgroundColor: "white",
                            border: "none",
                            padding: "0px !important",
                            fontSize: 12,
                            maxWidth: "200px !important",
                        },
                    }}
                    title={<HotelStatusTooltip status={status} />}
                >
                    <Chip
                        sx={{
                            backgroundColor: status.bg,
                            color: status.text,
                            fontWeight: 500,
                            fontSize: "12px !important ",
                        }}
                        icon={createElement(status.component(), {
                            fontSize: 14,
                            color: status.text,
                        })}
                        label={t(status.label || "")}
                    />
                </NoMaxWidthTooltip>
            )) ||
                "-"}
        </div>
    );
}

export const HotelNameColumn = ({ t }: { t: TFunction }): GridColDef<IPlanPassenger<"api">> => {
    return {
        field: "accommodation",
        headerName: t("accommodation"),
        minWidth: 170,
        maxWidth: 350,
        valueGetter: (_val, row) => row.hotelName || "",
        renderHeader: (params) => <TableHeader Component={TbBuildingSkyscraper} title={params.colDef.headerName!} />,
        renderCell: ({ value }) => <HotelNameColumnCell value={value} />,
    };
};
export default HotelNameColumn;
